import React, { useState } from "react";
import {
  Page,
  Layout,
  Card,
  Text,
  BlockStack,
  InlineStack,
  DataTable,
  Badge,
  EmptyState,
} from "@shopify/polaris";

export default function Coupons() {
  const [coupons] = useState(getMockCoupons());

  const totalDiscount = coupons.reduce((sum, c) => sum + c.discountTL, 0);
  const usedCount = coupons.filter((c) => c.used).length;
  const usageRate = coupons.length > 0 ? Math.round((usedCount / coupons.length) * 100) : 0;

  const rows = coupons.map((coupon) => [
    <Text fontWeight="bold" variant="bodyMd">
      {coupon.code}
    </Text>,
    coupon.customerName,
    `${new Intl.NumberFormat("tr-TR").format(coupon.discountTL)} TL`,
    `${coupon.pointsUsed} puan`,
    coupon.used ? (
      <Badge tone="success">Kullanildi</Badge>
    ) : new Date(coupon.expiresAt) < new Date() ? (
      <Badge tone="critical">Suresi Doldu</Badge>
    ) : (
      <Badge tone="info">Aktif</Badge>
    ),
    formatDate(coupon.createdAt),
    coupon.used ? formatDate(coupon.usedAt) : "-",
  ]);

  return (
    <Page title="Kuponlar" subtitle="Olusturulan loyalty kuponlari">
      <Layout>
        {/* Summary Stats */}
        <Layout.Section>
          <InlineStack gap="400" wrap={false}>
            <StatCard title="Toplam Kupon" value={coupons.length} />
            <StatCard title="Kullanilan" value={usedCount} />
            <StatCard title="Kullanim Orani" value={`%${usageRate}`} />
            <StatCard
              title="Toplam Indirim"
              value={`${new Intl.NumberFormat("tr-TR").format(totalDiscount)} TL`}
            />
          </InlineStack>
        </Layout.Section>

        <Layout.Section>
          <Card>
            {coupons.length === 0 ? (
              <EmptyState heading="Henuz kupon olusturulmamis">
                <p>Musteriler puanlarini kuponlara donusturdugunde burada gorunecek.</p>
              </EmptyState>
            ) : (
              <DataTable
                columnContentTypes={["text", "text", "numeric", "numeric", "text", "text", "text"]}
                headings={["Kupon Kodu", "Musteri", "Indirim", "Harcanan Puan", "Durum", "Olusturma", "Kullanim"]}
                rows={rows}
                hoverable
                sortable={[false, true, true, true, false, true, false]}
              />
            )}
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}

function StatCard({ title, value }) {
  return (
    <div
      style={{
        flex: 1,
        backgroundColor: "#fff",
        borderRadius: 8,
        padding: 20,
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
      }}
    >
      <Text variant="bodySm" tone="subdued">
        {title}
      </Text>
      <Text variant="headingLg" as="p" fontWeight="bold">
        {value}
      </Text>
    </div>
  );
}

function formatDate(dateStr) {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleDateString("tr-TR", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

function getMockCoupons() {
  return [
    { code: "BOLOYALTY-X7K2M4", customerName: "Ahmet Yilmaz", discountTL: 150, pointsUsed: 300, used: true, createdAt: "2026-04-10", usedAt: "2026-04-12", expiresAt: "2026-07-10" },
    { code: "BOLOYALTY-P9R3N1", customerName: "Mehmet Kaya", discountTL: 400, pointsUsed: 800, used: false, createdAt: "2026-04-13", usedAt: null, expiresAt: "2026-07-13" },
    { code: "BOLOYALTY-T5W8Q6", customerName: "Ayse Demir", discountTL: 50, pointsUsed: 100, used: true, createdAt: "2026-04-05", usedAt: "2026-04-08", expiresAt: "2026-07-05" },
    { code: "BOLOYALTY-A2B9C3", customerName: "Fatma Sahin", discountTL: 150, pointsUsed: 300, used: true, createdAt: "2026-03-28", usedAt: "2026-04-01", expiresAt: "2026-06-28" },
    { code: "BOLOYALTY-D4E1F7", customerName: "Can Bulut", discountTL: 50, pointsUsed: 100, used: false, createdAt: "2026-04-14", usedAt: null, expiresAt: "2026-07-14" },
    { code: "BOLOYALTY-G8H5J2", customerName: "Zeynep Arslan", discountTL: 750, pointsUsed: 1500, used: false, createdAt: "2026-03-15", usedAt: null, expiresAt: "2026-06-15" },
  ];
}
